module.exports = __webpack_public_path__ + "img/form-submission.5404a208.svg";